import { Component, OnInit } from "@angular/core";
// Services
import { ElasticService } from "./../../services/elastic";
// External
import { Club } from "./../../models/club";

import * as lodash from "lodash";
import { ApiService } from "./../../services/api";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-clubs",
  templateUrl: "./clubs.component.html",
})
export class ClubsComponent implements OnInit {
  public filterargs: Club;
  public imageLoader: boolean = true;
  public currentPage: number;
  public maxPage: number;
  public showVerified: boolean;
  public clubs: Array<Club>;

  public query: string;

  public typingDelay: any;
  public pageSize: number;

  constructor(
    private elasticService: ElasticService,
    private apiService: ApiService,
    private datePipe: DatePipe
  ) {
    this.currentPage = 0;
    this.pageSize = 20;
    this.showVerified = true;
    this.query = "";
  }
  confirmClub(club: Club) {
    if (confirm("Are you sure?")) {
      this.apiService
        .update(`/users/${club.$key}`, {
          isVerified: true,
          updatedAt: new Date().getTime() / 1000,
        })
        .then(() => {
          const clubIndex = this.clubs.indexOf(club);
          this.clubs.splice(clubIndex, 1);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  ngOnInit() {
    this.filterargs = new Club();
    this.goToPage(this.currentPage);
  }

  showChange(isVerified: boolean) {
    this.showVerified = isVerified;
    this.goToPage(0);
  }

  goToPage(index: number) {
    const fromIndex = index * this.pageSize;
    let queryParams = {};

    if (this.query == undefined || this.query == "") {
      queryParams = {
        index: "users",
        type: "club",
        size: this.pageSize,
        from: fromIndex,
        "body/query/bool/must/query_string/query": `${this.query}*`,
        "body/query/bool/must/query_string/fields": ["name"],
        "body/sort/registerDate/order": "desc",
        // "body/sort/_geo_distance/order": "asc",
        // "body/sort/_geo_distance/location/lat": 22.71,
        // "body/sort/_geo_distance/location/lon": 75.85,
        // "body/sort/_geo_distance/unit": "km",
        // "body/sort/_geo_distance/distance_type": "plane",
      };
    } else {
      queryParams = {
        index: "users",
        type: "club",
        size: this.pageSize,
        from: fromIndex,
        "body/query/match_phrase_prefix/name": `${this.query}*`,
      };
    }

    if (this.showVerified) {
      queryParams = {
        index: "users",
        type: "club",
        size: 500,
        from: fromIndex,
        "body/query/match_phrase_prefix/isVerified": `true`,

        "body/sort/registerDate/order": `desc`,
      };
    }

    this.elasticService
      .search(queryParams)
      .then((result) => {
        if (result) {
          this.clubs = [];
          lodash.forEach(result["hits"], (item) => {
            const club = item["_source"];
            let daysLeft = 0;
            let status = "";
            let type = "";
            const now = new Date();
            if (club["bank"] != undefined && club["bank"]["stripe_user_id"]) {
              club.isStripe = true;
            } else {
              club.isStripe = false;
            }
            if (club["subscription"]) {
              if (club["subscription"] * 1000 > now.getTime()) {
                daysLeft = Math.round(
                  Math.abs(
                    (club["subscription"] * 1000 - now.getTime()) /
                      (24 * 60 * 60 * 1000)
                  )
                );
                status = "Running";
                type = "Subscription";
              } else {
                daysLeft = 0;
                status = "Expired";
                type = "Subscription";
              }
              const d = new Date(club["subscription"] * 1000);
              d.setDate(d.getDate());
              club["subscription"] = `${d.getDate()}-${
                d.getMonth() + 1
              }-${d.getFullYear()}`;
            } else {
              if (club["trial"]) {
                if (club["trial"] * 1000 > now.getTime()) {
                  daysLeft = Math.round(
                    Math.abs(
                      (club["trial"] * 1000 - now.getTime()) /
                        (24 * 60 * 60 * 1000)
                    )
                  );
                  status = "Running";
                  type = "Trial Period";
                } else {
                  daysLeft = 0;
                  status = "Expired";
                  type = "Trial Period";
                }
                const d = new Date(club["trial"] * 1000);
                d.setDate(d.getDate());
                club["trial"] = `${d.getDate()}-${
                  d.getMonth() + 1
                }-${d.getFullYear()}`;
                // club['trial'] = this.datePipe.transform(club['trial'] * 1000, 'YY-MM-DD')
              } else {
                daysLeft = 0;
                status = "Expired";
                type = "Trial Period";
              }
            }
            club.subType = type;
            club.subStatus = status;
            club.subDayleft = daysLeft;
            this.clubs.push(lodash.assign({ $key: item["_id"] }, club));
          });

          window.scrollTo(0, 0);
          this.currentPage = index;
          this.maxPage = Math.ceil(result["total"] / this.pageSize);
        } else {
          this.clubs = [];
        }
        this.imageLoader = false;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }

  getIndex(index: number) {
    return this.currentPage * this.pageSize + index + 1;
  }
  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.goToPage(this.currentPage);
    }, 400);
  }
  reset(club) {
    console.log(club);
    if (confirm("Are you sure? you want to Reset this club")) {
      this.apiService
        .update(`/users/${club.$key}`, {
          isVerified: null,
          updatedAt: new Date().getTime() / 1000,
          registerDate: null,
          uid: null,
          email: null,

          phone: null,
        })
        .then(() => {
          const clubIndex = this.clubs.indexOf(club);
          this.clubs.splice(clubIndex, 1);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  suspend(club) {
    console.log(club);
    if (confirm("Are you sure? you want to Suspend this club")) {
      this.apiService
        .update(`/users/${club.$key}`, {
          updatedAt: new Date().getTime() / 1000,
          status: 2,
        })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  unsuspend(club) {
    console.log(club);
    if (confirm("Are you sure? you want to Unsuspend this club")) {
      this.apiService
        .update(`/users/${club.$key}`, {
          updatedAt: new Date().getTime() / 1000,
          status: null,
        })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
